import type { ComponentRef, EditorSDK } from '@wix/platform-editor-sdk';

import { APP_TOKEN } from '../constants';

export function deselectComponents(editorSDK: EditorSDK, compsToDeselect: ComponentRef[]) {
  return editorSDK.editor.selection.deselectComponents(APP_TOKEN, { compsToDeselect });
}
